import { useNavigate } from 'react-router-dom';
import { Building2, Package } from 'lucide-react';
import { S, DpoBeamBackground, EMBEDDED_CSS } from './distributorPoShared';

/* ============================================================================
 * Distributor Master — home landing. Two option cards, each opening its own
 * dedicated page (DistributorMasterRows.jsx / DistributorMasterSkus.jsx),
 * matching the DistributorPO.jsx home-screen pattern.
 * ========================================================================== */

export default function DistributorMaster() {
  const navigate = useNavigate();

  return (
    <div className="dpo-page" data-tutorial="distributor-master-table" style={S.page}>
      <style>{EMBEDDED_CSS}</style>

      <div style={S.headerBar}>
        <DpoBeamBackground />
        <h1 style={{ ...S.h1, position: 'relative', zIndex: 1 }}>Distributor <span style={{ fontWeight: 600, color: '#C9B7EA' }}>Master</span></h1>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '320px 320px', gap: 16 }}>
        <button style={S.homeOptionCard} onClick={() => navigate('/dms/distributor-master/distributors')}>
          <span style={S.homeOptionIcon}><Building2 size={28} /></span>
          <div>
            <div style={S.homeOptionTitle}>Distributors &amp; Platforms</div>
            <div style={S.homeOptionSub}>Margin, region, and location per distributor + platform</div>
          </div>
        </button>
        <button style={S.homeOptionCard} onClick={() => navigate('/dms/distributor-master/skus')}>
          <span style={S.homeOptionIcon}><Package size={28} /></span>
          <div>
            <div style={S.homeOptionTitle}>SKU Catalog</div>
            <div style={S.homeOptionSub}>EAN, pricing, and margins per distributor + platform</div>
          </div>
        </button>
      </div>
    </div>
  );
}
